import { HttpProvider } from "../http/http.provider";
import { addProvider, IProviderDescriptor, ServiceEndpointConstants } from "../ServiceUtil";
import { IHttpRequestConfig } from "../http";
import { ICandidateResponse, ICandidate, IClientResponses, IClientSpocResponse, IClientSpoc, ICreateClient, IDeleteJobSubmissionResponse, IInterViewPanelResponse, IJobCode, IJobCodeResponse, IJobSubmission, IJobSubmissionResponse, INewCandidate, INewCandidateBulk, INewClientSpoc, INewClientSpocBulk, INewInterViewPanel, INewJCTAMapping, INewJobCode, INewJobSubmission, IJCTAMapping, INewCandidateDocument, ICandidateDocument, IInterViewPanel, IJobInterviewResponse, INewJobInterview, IJobInterview, MultiselectCJC, ICreateMultiSelectCJCResponse, ITAMember, ITAMemberResponse, INewJobCodeDocument, IJobCodeDocumentsResponse, IJobCodeDocument, IUploadResumeRequest, IUploadResumeResponse, IUploadBulkResumesRequest, IUploadBulkResumesResponse, IQueryResumesRequest, IMatchJobDescriptionRequest, IResumeQueryResult } from "./hmFlow.interface";
import { Observable, of } from "rxjs";
import { createFormData } from "../util/utilities";
import { map, share, catchError } from "rxjs/operators";
/**
 * 
 */

export class HMFlowDelegate {

    constructor(private http: HttpProvider) {
    }

    public getAllHmCandidates(orgId: string, taId?: string, pageNumber?: number, pageSize?: number, searchTerm?: string): Observable<ICandidateResponse> {
        const url = ServiceEndpointConstants.endpoints.CANDIDATE.GET_ALL_CANDIDATES + orgId;
        const config: IHttpRequestConfig = {
            params: {
                EmployeeId: taId,
                pageNumber: pageNumber,
                pageSize: pageSize,
                searchTerm: searchTerm
            }
        }
        return this.http.get(url, null, config).pipe(
            map((response: any) => {
                return {
                    candidates: response.data.candidates,
                    success: response.data.success,
                    totalCount: response.data.totalCount,
                    pageNumber: response.data.pageNumber,
                    pageSize: response.data.pageSize,
                    totalPages: response.data.totalPages
                };
            }),
            share()
        );
    }
    public getCandidateByCandidateId(candidateId: string): Observable<ICandidateResponse> {
        const url = ServiceEndpointConstants.endpoints.CANDIDATE.GET_CANDIDATE_BY_ID + candidateId;
        return this.http.get(url).pipe(
            map((response: any) => {
                return {
                    candidate: response.data.candidate,
                    candidateId: candidateId,
                    success: response.data.success
                };
            }),
            share());
    }

    public createNewCandidate(newCandidate: INewCandidate): Observable<ICandidateResponse> {
        return this.http.post(ServiceEndpointConstants.endpoints.CANDIDATE.CREATE_CANDIDATE, newCandidate).pipe(
            map((response: any) => {
                return {
                    candidate: response.data.candidate,
                    candidateId: response.data.candidateId,
                    success: response.data.success
                };
            }),
            share());
    }

    public updateCandidate(candidate: ICandidate): Observable<ICandidateResponse> {
        const url = ServiceEndpointConstants.endpoints.CANDIDATE.UPDATE_CANDIDATE_BY_ID + candidate.candidateId;
        return this.http.post(url, candidate).pipe(
            map((response: any) => {
                return {
                    candidate: response.data.candidate,
                    candidateId: candidate.candidateId,
                    success: response.data.success
                };
            }),
            share());
    }

    public getAllJobCodes(orgId: string, taId?: string): Observable<IJobCodeResponse> {
        const url = ServiceEndpointConstants.endpoints.JOBCODE.GET_ALL_JOBCODES + orgId;
        const config: IHttpRequestConfig = {
            params: {
                EmployeeId: taId
            }
        }
        return this.http.get(url, null, config).pipe(
            map((response: any) => {
                return {
                    jobCodes: (response.data.jobCodes || []).map((jc: any) => this.normalizeJobCode(jc)),
                    success: response.data.success
                };
            }),
            share()
        );
    }

    public getJobCodeByJobCodeId(jobCodeId: string): Observable<IJobCodeResponse> {
        const url = ServiceEndpointConstants.endpoints.JOBCODE.GET_JOBCODE_BY_ID + jobCodeId;
        return this.http.get(url).pipe(
            map((response: any) => {
                return {
                    jobCode: this.normalizeJobCode(response.data.jobCode),
                    jobCodeId: jobCodeId,
                    success: response.data.success
                };
            }),
            share());
    }

    public createNewJobCode(jobCode: INewJobCode): Observable<IJobCodeResponse> {
        return this.http.post(ServiceEndpointConstants.endpoints.JOBCODE.CREATE_JOBCODE, jobCode).pipe(
            map((response: any) => {
                return {
                    jobCode: response.data.jobCode,
                    jobCodeId: response.data.jobCodeId,
                    success: response.data.success
                };
            }),
            share());
    }

    public updateJobCode(jobCode: IJobCode): Observable<IJobCodeResponse> {
        return this.http.post(ServiceEndpointConstants.endpoints.JOBCODE.UPDATE_JOBCODE, jobCode).pipe(
            map((response: any) => {
                return {
                    jobCode: response.data.jobCode,
                    jobCodeId: jobCode.jobCodeId,
                    success: response.data.success
                };
            }),
            share());
    }
    public assignTAJC(assign: INewJCTAMapping): Observable<IJobCodeResponse> {
        return this.http.post(ServiceEndpointConstants.endpoints.JOBCODE.ASSIGN_TAJC, assign).pipe(
            map((response: any) => {
                return {
                    jobCode: response.data.jobCode,
                    jctamappingId: response.data.jctamappingId,
                    success: response.data.success
                };
            }),
            share());
    }

    public unAssignTAJC(assign: IJCTAMapping): Observable<IJobCodeResponse> {
        return this.http.post(ServiceEndpointConstants.endpoints.JOBCODE.UNASSIGN_TAJC, assign).pipe(
            map((response: any) => {
                return {
                    jobCode: response.data.jobCode,
                    jctamappingId: response.data.jctamappingId,
                    success: response.data.success
                }
            }),
            share());
    }

    public getAllJobSubmissions(orgId: string, taId?: string): Observable<IJobSubmissionResponse> {
        const url = ServiceEndpointConstants.endpoints.JOBSUBMISSION.GET_ALL_JOBSUBMISSIONS + orgId;
        const config: IHttpRequestConfig = {
            params: {
                EmployeeId: taId
            }
        }
        return this.http.get(url, null, config).pipe(
            map((response: any) => {
                return {
                    jobSubmissions: this.normalizeJobSubmissions(response.data.jobSubmissions),
                    success: response.data.success
                };
            }),
            share());
    }

    public getAllTAMembers(orgId: string, clientId?: string, employeeId?:string): Observable<ITAMemberResponse> {
        const url = ServiceEndpointConstants.endpoints.JOBSUBMISSION.GET_ALL_TA_MEMBERS + orgId;
        const config: IHttpRequestConfig = {
            params: {
                clientId: clientId,
                employeeId: employeeId
            }
        };
        return this.http.get(url, null, config).pipe(
            map((response: any) => {
                const rawList: any[] = response.data.taMembers || response.data || [];
                const taMembers: ITAMember[] = (rawList || []).map((m: any) => ({
                    employeeId: m.employeeId || m.EmployeeId,
                    userId: m.userId || m.UserId,
                    firstName: m.firstName || m.FirstName,
                    lastName: m.lastName || m.LastName,
                    email: m.email || m.Email,
                    roleId: m.roleId || m.RoleId,
                    roleName: m.roleName || m.RoleName,
                    managerId: m.managerId || m.ManagerId,
                    managerName: m.managerName || m.ManagerName,
                    orgId: m.orgId || m.OrgId,
                    isActive: m.isActive !== undefined ? m.isActive : m.IsActive,
                    fullName: ((m.firstName || m.FirstName || '') + ' ' + (m.lastName || m.LastName || '')).trim()
                }));
                return {
                    taMembers: taMembers,
                    success: response.data.success !== undefined ? response.data.success : true
                };
            }),
            share());
    }

    public getJobSubmissionById(jobSubmissionId: string): Observable<IJobSubmissionResponse> {
        const url = ServiceEndpointConstants.endpoints.JOBSUBMISSION.GET_JOBSUBMISSION_BY_ID + jobSubmissionId;
        return this.http.get(url).pipe(
            map((response: any) => {
                return {
                    jobSubmission: this.normalizeJobSubmission(response.data.jobSubmission),
                    jobSubmissionId: jobSubmissionId,
                    success: response.data.success
                };
            }),
            share());
    }

    public createNewJobSubmission(jobSubmission: MultiselectCJC): Observable<ICreateMultiSelectCJCResponse> {
        return this.http.post(ServiceEndpointConstants.endpoints.JOBSUBMISSION.CREATE_JCJSC_BULK, jobSubmission).pipe(
            map((response: any) => {
                return {
                    created: this.normalizeJobSubmissions(response.data.created),
                    skipped: response.data.skipped,
                    createdCount: response.data.createdCount,
                    skippedCount: response.data.skippedCount,
                    success: response.data.success
                } as ICreateMultiSelectCJCResponse;
            }),
            share());
    }

    public updateJobSubmission(jobSubmission: IJobSubmission): Observable<IJobSubmissionResponse> {
        return this.http.post(ServiceEndpointConstants.endpoints.JOBSUBMISSION.UPDATE_JOBSUBMISSION, jobSubmission).pipe(
            map((response: any) => ({
                jobSubmission: this.normalizeJobSubmission(response.data.jobSubmission),
                jobSubmissionId: jobSubmission.jobSubmissionId,
                success: response.data.success
            })),
            share());
    }

    public deleteJobSubmission(jobSubmissionId: string): Observable<IDeleteJobSubmissionResponse> {
        const url = ServiceEndpointConstants.endpoints.JOBSUBMISSION.DELETE_JOBSUBMISSION + jobSubmissionId;
        return this.http.delete(url).pipe(
            map((response: any) => {
                return {
                    jobSubmissionId: response.data.jobSubmissionId,
                    success: response.data.success
                };
            }),
            share());
    }
    public getClientspocByClientspocId(clientSpocId: string): Observable<IJobSubmissionResponse> {
        const config: IHttpRequestConfig = {
            params: {
                ClientSpocId: clientSpocId
            }
        };
        return this.http.get(ServiceEndpointConstants.endpoints.CLIENTSPOC.GET_CLIENTSPOC_BY_ID, null, config).pipe(
            map((response: any) => {
                return {
                    clientSpoc: response.data.clientSpoc,
                    clientSpocId: clientSpocId,
                    success: response.data.success
                };
            }),
            share());
    }

    public getAllClientSpocs(): Observable<IClientSpocResponse> {
        const url = ServiceEndpointConstants.endpoints.CLIENTSPOC.GET_CLIENTSPOC_BY_ID;
        return this.http.get(url).pipe(
            map((response: any) => {
                return {
                    clientSpocs: response.data.clientSpocs,
                    success: response.data.success
                };
            }),
            share());
    }

    public createNewClientSpoc(clientspoc: INewClientSpoc): Observable<IClientSpocResponse> {
        return this.http.post(ServiceEndpointConstants.endpoints.CLIENTSPOC.CREATE_CLIENTSPOC, clientspoc).pipe(
            map((response: any) => {
                return {
                    clientSpoc: response.data.clientSpoc,
                    clientSpocId: response.data.clientSpocId,
                    success: response.data.success
                };
            }),
            share());
    }

    public createNewClientSpocBulk(clientSpoc: INewClientSpocBulk): Observable<IClientSpocResponse> {
        const formdata = createFormData(clientSpoc);

        return this.http.post(ServiceEndpointConstants.endpoints.CLIENTSPOC.CREATE_CLIENTSPOC_BULK, formdata).pipe(
            map((response: any) => {
                return {
                    clientSpocs: response.data.clientSpocs,
                    success: response.data.success
                };
            }),
            share());
    }

    public updateClientSpoc(clientspoc: IClientSpoc): Observable<IClientSpocResponse> {
        return this.http.post(ServiceEndpointConstants.endpoints.CLIENTSPOC.UPDATE_CLIENTSPOC, clientspoc).pipe(
            map((response: any) => {
                return {
                    clientSpoc: response.data.clientSpoc,
                    clientSpocId: clientspoc.clientSpocId,
                    success: response.data.success
                };
            }),
            share());
    }
    public createClient(client: ICreateClient): Observable<IClientResponses> {
        return this.http.post(ServiceEndpointConstants.endpoints.CLIENTSPOC.CREATE_CLIENT, client).pipe(
            map((response: any) => {
                return {
                    client: response.data.client,
                    clientId: response.data.clientId,
                    success: response.data.success
                };
            }),
            share());
    }

    public updateClient(client: ICreateClient): Observable<IClientResponses> {
        return this.http.post(ServiceEndpointConstants.endpoints.CLIENTSPOC.UPDATE_CLIENT, client).pipe(
            map((response: any) => {
                return {
                    client: response.data.client,
                    clientId: response.data.clientId,
                    success: response.data.success
                };
            }),
            share());
    }

    public updateDefaultClient( userId: string, clientId: string ): Observable<boolean> {
        const request = {
            userId: userId,
            clientId: clientId,
            clientTimeStamp: new Date().toISOString()
        };
        return this.http.post(ServiceEndpointConstants.endpoints.CLIENTSPOC.UPDATE_CLIENT_ID,request).pipe(
            share()
        );
    }
    
    public getClientById(clientId: string): Observable<IClientResponses> {
        const url = ServiceEndpointConstants.endpoints.CLIENTSPOC.GET_CLIENT_BY_ID + clientId;
        return this.http.get(url).pipe(
            map((response: any) => {
                return {
                    client: response.data.client,
                    clientId: clientId,
                    success: response.data.success
                };
            }),
            share());
    }
    public createNewCandidateBulk(candidate: INewCandidateBulk): Observable<ICandidateResponse> {
        const formdata = createFormData(candidate);

        return this.http.post(ServiceEndpointConstants.endpoints.CANDIDATE.CREATE_CANDIDATE_BULK, formdata).pipe(
            map((response: any) => {
                return {
                    candidates: response.data.candidates,
                    success: response.data.success
                };
            }),
            share());
    }
    public uploadResume(request: IUploadResumeRequest): Observable<IUploadResumeResponse> {
        const formdata = createFormData(request);

        return this.http.post(ServiceEndpointConstants.endpoints.DOCUMENT_INTELLIGENCE.UPLOAD_RESUME, formdata).pipe(
            map((response: any) => {
                return {
                    success: response.data.success,
                    error: response.data.error,
                    message: response.data.message,
                    candidateId: response.data.candidateId,
                    candidateDocumentId: response.data.candidateDocumentId,
                    candidateCreated: response.data.candidateCreated,
                    s3Key: response.data.s3Key,
                    parsedResume: response.data.parsedResume
                };
            }),
            catchError((error: any) => {
                const data = error && error.data ? error.data : {};
                return of({
                    success: false,
                    error: data.error || data.message || error?.message,
                    message: data.message,
                    parsedResume: data.parsedResume
                } as IUploadResumeResponse);
            }),
            share());
    }

    public uploadBulkResumes(request: IUploadBulkResumesRequest): Observable<IUploadBulkResumesResponse> {
        const formdata = createFormData(request);

        return this.http.post(ServiceEndpointConstants.endpoints.DOCUMENT_INTELLIGENCE.UPLOAD_BULK_RESUMES, formdata).pipe(
            map((response: any) => {
                return {
                    totalFiles: response.data.totalFiles,
                    succeeded: response.data.succeeded,
                    failed: response.data.failed,
                    items: response.data.items || []
                };
            }),
            catchError((error: any) => {
                return of({
                    totalFiles: 0,
                    succeeded: 0,
                    failed: 0,
                    items: []
                } as IUploadBulkResumesResponse);
            }),
            share());
    }

    public queryResumes(request: IQueryResumesRequest): Observable<IResumeQueryResult> {
        return this.http.post(ServiceEndpointConstants.endpoints.DOCUMENT_INTELLIGENCE.QUERY_RESUMES, request).pipe(
            map((response: any) => {
                return {
                    answer: response.data.answer,
                    sources: response.data.sources || [],
                    message: response.data.message
                } as IResumeQueryResult;
            }),
            catchError((error: any) => {
                const data = error && error.data ? error.data : {};
                return of({
                    answer: '',
                    sources: [],
                    message: data.message || data.error || error?.message || 'Search failed'
                } as IResumeQueryResult);
            }),
            share());
    }

    public matchJobDescription(request: IMatchJobDescriptionRequest): Observable<IResumeQueryResult> {
        return this.http.post(ServiceEndpointConstants.endpoints.DOCUMENT_INTELLIGENCE.MATCH_JOB_DESCRIPTION, request).pipe(
            map((response: any) => {
                return {
                    answer: response.data.answer,
                    sources: response.data.sources || [],
                    message: response.data.message
                } as IResumeQueryResult;
            }),
            catchError((error: any) => {
                const data = error && error.data ? error.data : {};
                return of({
                    answer: '',
                    sources: [],
                    message: data.message || data.error || error?.message || 'Search failed'
                } as IResumeQueryResult);
            }),
            share());
    }

    public createNewJobCodeBulk(jobcode: INewCandidateBulk): Observable<IJobCodeResponse> {
        const formdata = createFormData(jobcode);

        return this.http.post(ServiceEndpointConstants.endpoints.JOBCODE.CREATE_JOBCODE_BULK, formdata).pipe(
            map((response: any) => {
                return {
                    jobCodes: response.data.jobCodes,
                    success: response.data.success
                };
            }),
            share());
    }
    public createNewJobSubmissionBulk(jobsubmission: INewCandidateBulk): Observable<IJobSubmissionResponse> {
        const formdata = createFormData(jobsubmission);
        return this.http.post(ServiceEndpointConstants.endpoints.JOBSUBMISSION.CREATE_JOBSUBMISSION_BULK, formdata).pipe(
            map((response: any) => {
                return {
                    jobSubmissions: response.data.jobsubmissions,
                    success: response.data.success
                };
            }),
            share());
    }

    public createCandidateDocument(candidateDocument: INewCandidateDocument): Observable<ICandidateResponse> {
        const formdata = createFormData(candidateDocument);

        return this.http.post(ServiceEndpointConstants.endpoints.CANDIDATE.CREATE_CANDIDATE_DOCUMENT, formdata).pipe(
            map((response: any) => {
                return {
                    candidateId: candidateDocument.candidateId,
                    candidate: response.data.candidate,
                    success: response.data.success,
                };
            }),
            share());
    }

    public uploadJobCodeDocument(jobCodeDocument: INewJobCodeDocument): Observable<IJobCodeDocumentsResponse> {
        const formdata = createFormData(jobCodeDocument);

        return this.http.post(ServiceEndpointConstants.endpoints.JOBCODE.UPLOAD_JOBCODE_DOCUMENT, formdata).pipe(
            map((response: any) => {
                return {
                    success: response.data.success,
                    jobCodeId: jobCodeDocument.jobCodeId,
                    documents: response.data.documents || []
                } as IJobCodeDocumentsResponse;
            }),
            share());
    }

    public createNewInterviewPanel(interviewPanel: INewInterViewPanel): Observable<IInterViewPanelResponse> {
        return this.http.post(ServiceEndpointConstants.endpoints.INTERVIEWPANEL.CREATE_INTERVIEWPANEL, interviewPanel).pipe(
            map((response: any) => {
                return {
                    interviewPanelAvailability: response.data.interviewPanelAvailability,
                    interviewPanelAvailabilityId: response.data.interviewPanelAvailabilityId,
                    success: response.data.success
                };
            }),
            share());
    }

    public updateInterviewPanel(interviewPanel: IInterViewPanel): Observable<IInterViewPanelResponse> {
        const url = ServiceEndpointConstants.endpoints.INTERVIEWPANEL.UPDATE_INTERVIEVPANEL + interviewPanel.interviewPanelAvailabilityId;
        return this.http.post(url, interviewPanel).pipe(
            map((response: any) => {
                return {
                    interviewPanelAvailability: response.data.interviewPanelAvailability,
                    interviewPanelAvailabilityId: interviewPanel.interviewPanelAvailabilityId,
                    success: response.data.success
                };
            }),
            share());
    }

    public getInterviewPanelAvailabilityById(interviewPanelAvailabilityId?: string): Observable<IInterViewPanelResponse> {

        const config: IHttpRequestConfig = {
            params: {
                InterviewPanelAvailabilityId: interviewPanelAvailabilityId
            }
        }
        return this.http.get(ServiceEndpointConstants.endpoints.INTERVIEWPANEL.GET_ALL_INTERVIEVPANELS, null, config).pipe(
            map((response: any) => {
                return {
                    interviewPanelAvailability: response.data.interviewPanelAvailability,
                    interviewPanelAvailabilityId: interviewPanelAvailabilityId,
                    success: response.data.success
                };
            }),
            share());
    }


    public getAllInterviewPanels(jobCodeId?: string): Observable<IInterViewPanelResponse> {

        const config: IHttpRequestConfig = {
            params: {
                JobCodeId: jobCodeId
            }
        }
        return this.http.get(ServiceEndpointConstants.endpoints.INTERVIEWPANEL.GET_ALL_INTERVIEVPANELS, null, config).pipe(
            map((response: any) => {
                return {
                    interviewPanelAvailabilities: response.data.interviewPanelAvailabilities,
                    success: response.data.success
                };
            }),
            share());
    }

   public getInterviewPanelsWithFreeSlots(jobCodeId: string, slotMinutes: number): Observable<IInterViewPanelResponse> {
       const config: IHttpRequestConfig = {
           params: {
               JobCodeId: jobCodeId,
               includeFreeSlots: true,
               slotMinutes: slotMinutes
           }
       }
       return this.http.get(ServiceEndpointConstants.endpoints.INTERVIEWPANEL.GET_ALL_INTERVIEVPANELS, null, config).pipe(
           map((response: any) => {
               return {
                   interviewPanelAvailabilities: response.data.interviewPanelAvailabilities,
                   success: response.data.success
               };
           }),
           share());
   }

   public getOrgInterviewPanels(orgId: string, employeeId: string): Observable<IInterViewPanelResponse> {
       const config: IHttpRequestConfig = {
           params: {
               employeeId: employeeId
           }
       }
       return this.http.get(ServiceEndpointConstants.endpoints.INTERVIEWPANEL.GET_ORG_INTERVIEWPANELS + orgId, null, config).pipe(
           map((response: any) => {
               return {
                   interviewPanelAvailabilities: response.data.interviewPanelAvailabilities,
                   success: response.data.success
               };
           }),
           share());
   }

   public getAllJobInterviews(orgId: string, taid?: string): Observable<IJobCodeResponse> {
        const url = ServiceEndpointConstants.endpoints.JOBSUBMISSION.GET_ALL_INTERVIEWS + orgId;
        const config: IHttpRequestConfig = {
            params: {
                TaId: taid
            }
        }
        return this.http.get(url, null, config).pipe(
            map((response: any) => {
                return {
                    jobInterviews: response.data.jobInterviews,
                    success: response.data.success
                };
            }),
            share()
        );
    }

    public getJobInterviewById(jobInterviewId: string): Observable<IJobInterviewResponse> {
        const url = ServiceEndpointConstants.endpoints.JOBSUBMISSION.GET_JOBINTERVIEW_BY_ID + jobInterviewId;
        return this.http.get(url).pipe(
            map((response: any) => {
                return {
                    jobInterview: response.data.jobInterview,
                    jobInterviewId: jobInterviewId,
                    success: response.data.success
                };
            }),
            share());
    }

    public createNewJobInerview(jobInterview: INewJobInterview): Observable<IJobInterviewResponse> {
        return this.http.post(ServiceEndpointConstants.endpoints.JOBSUBMISSION.CREATE_JOBINTERVIEW, jobInterview).pipe(
            map((response: any) => {
                return {
                    jobInterview: response.data.jobInterview,
                    jobInterviewId: response.data.jobInterviewId,
                    success: response.data.success
                };
            }),
            share());
    }

    public updateJobInterview(jobInterview: IJobInterview): Observable<IJobInterviewResponse> {
        return this.http.post(ServiceEndpointConstants.endpoints.JOBSUBMISSION.UPDATE_JOBINTERVIEW, jobInterview).pipe(
            map((response: any) => {
                return {
                    jobInterview: response.data.jobInterview,
                    jobInterviewId: jobInterview.jobInterviewId,
                    success: response.data.success
                };
            }),
            share());
    }

    private normalizeJobSubmission(jobSubmission: any): IJobSubmission {
        const candidate = jobSubmission.candidate;
        const jobCode = jobSubmission.jobCode;
        jobSubmission.candidateFullName = candidate.fullName;
        jobSubmission.candidateId = candidate.candidateId;
        jobSubmission.jobCodeId = jobCode.jobCodeId;
        jobSubmission.candidateEmail = candidate.emailAddress;
        jobSubmission.clientJobCodeNumber = jobCode.clientJobCodeNumber;
        jobSubmission.jobTitle = jobCode.jobTitle;
        jobSubmission.interviewPanelAvailabilities = jobCode.interviewPanelAvailabilities || [];
        jobSubmission.jobsubmissionName = `${jobSubmission.candidateFullName} - ${jobSubmission.clientJobCodeNumber}`;
        jobSubmission.jobInterviews = this.normalizeJobInterviews(jobSubmission.jobInterviews || []);

        delete jobSubmission.candidate;
        delete jobSubmission.jobCode;

        return jobSubmission;
    }

    private normalizeJobSubmissions(jobSubmissions: any[]): IJobSubmission[] {
        return jobSubmissions.map(jobSubmission => {
            return this.normalizeJobSubmission(jobSubmission);
        });
    }

    private normalizeJobInterviews(jobInterviews: any[]): any[] {
        return jobInterviews.map(interview => {
            return {
                jobInterviewId: interview.jobInterviewId,
                jobSubmissionId: interview.jobSubmissionId,
                interviewPanelAvailabilityId: interview.interviewPanelAvailabilityId,
                interviewDate: interview.interviewDate,
                startTime: interview.startTime,
                endTime: interview.endTime,
                interviewStatus: interview.interviewStatus,
                comments: interview.comments,
                createdDateTime: interview.createdDateTime,
                createdBy: interview.createdBy,
                modifiedDateTime: interview.modifiedDateTime,
                modifiedBy: interview.modifiedBy
            };
        });
    }

    private normalizeCandidates(candidates: any): ICandidate[] {
        return candidates.map(candidate => {
            return this.normalizeCandidate(candidate);
        });
    }

    private normalizeCandidate(candidate: any): ICandidate {
        candidate.candidateDocuments = this.normalizeCandidateDocuments(candidate.candidateDocuments);
        return candidate;
    }

    private normalizeCandidateDocuments(docs: any): ICandidateDocument[] {
        return docs.map(doc => {
            return {
                candidateDocumentId: doc.candidateDocumentId,
                candidateId: doc.candidateId,
                documentTypeId: doc.documentTypeId,
                documentType: doc.documentType,
                documentTypeName: doc.documentType ? doc.documentType.configurationValue : '',
                documentTypeCategory: doc.documentType ? doc.documentType.configurationCategory : '',
                documentTypeRequired: doc.documentType ? doc.documentType.required : false,
                uploadedFileName: doc.uploadedFileName,
                savedFileName: doc.savedFileName,
                fileLocationPath: doc.fileLocationPath,
                status: doc.status,
                createdDateTime: doc.createdDateTime,
                createdBy: doc.createdBy
            } as ICandidateDocument;
        });
    }

    private normalizeJobCode(jobCode: any): IJobCode {
        if (!jobCode) { return jobCode; }
        jobCode.jobCodeDocuments = this.normalizeJobCodeDocuments(jobCode.jobCodeDocuments || jobCode.documents || []);
        return jobCode;
    }

    private normalizeJobCodeDocuments(docs: any[]): IJobCodeDocument[] {
        return (docs || []).map((doc: any) => {
            return {
                jobCodeDocumentId: doc.jobCodeDocumentId,
                jobCodeId: doc.jobCodeId,
                uploadedFileName: doc.uploadedFileName,
                savedFileName: doc.savedFileName,
                fileLocationPath: doc.fileLocationPath,
                createdDateTime: doc.createdDateTime,
                createdBy: doc.createdBy,
                modifiedDateTime: doc.modifiedDateTime,
                modifiedBy: doc.modifiedBy
            } as IJobCodeDocument;
        });
    }
}
























